define('TescoMobile_Checkout/js/form/element/email',['Magento_Ui/js/form/element/abstract', 'jquery', 'Magento_Checkout/js/model/quote', 'Magento_Checkout/js/checkout-data'], function (Component, $, quote, checkoutData) {
  'use strict';

  var validatedEmail;
  const aboutEmailFormSelector = 'form[data-role=about-email-form]';
  if (!checkoutData.getValidatedEmailValue() && window.checkoutConfig.validatedEmailValue) {
    checkoutData.setInputFieldEmailValue(window.checkoutConfig.validatedEmailValue);
    checkoutData.setValidatedEmailValue(window.checkoutConfig.validatedEmailValue);
  }
  validatedEmail = checkoutData.getValidatedEmailValue();
  if (validatedEmail) {
    quote.guestEmail = validatedEmail;
  }
  return Component.extend({
    defaults: {
      isConfirmEmailVisible: true,
      template: 'TescoMobile_Checkout/form/element/email',
      emailFocused: false,
      email: checkoutData.getInputFieldEmailValue(),
      confirmEmail: checkoutData.getValidatedEmailValue(),
      confirmEmailFocused: false,
      emailCheckTimeout: 0,
      checkDelay: window.checkoutConfig.tescomobile.about.email_validation_delay,
      checkUserNameRequired: window.checkoutConfig.tescomobile.about.email_validation_exist_required,
      isLoading: false,
      checkRequest: null,
      emailExist: false,
      isEmailCheckComplete: null,
      listens: {
        email: 'emailHasChanged',
        emailFocused: 'validateEmail',
        confirmEmail: 'validateConfirmEmail',
        confirmEmailFocused: 'validateConfirmEmail',
        '${ $.provider }:${ $.customScope ? $.customScope + "." : ""}data.validate': 'validateEmailSubmit'
      }
    },
    initObservable: function () {
      return this._super().observe(['email', 'confirmEmail', 'emailFocused', 'isConfirmEmailVisible', 'isLoading', 'emailExist']);
    },
    emailHasChanged: function () {
      var self = this;
      if (this.validateEmail()) {
        quote.guestEmail = self.email();
        self.isConfirmEmailVisible(true);
        checkoutData.setValidatedEmailValue(self.email());
      }
      $('#customer-email-main-form').val(this.email());
      checkoutData.setInputFieldEmailValue(self.email());
    },
    validateEmailSubmit: function () {
      var emailSelector = aboutEmailFormSelector + ' input[name=email]',
        emailForm = $(aboutEmailFormSelector),
        validator,
        valid,
        self = this;
      $('#customer-email-main-form').val(self.email());
      emailForm.validation();
      valid = !!$(emailSelector).valid();
      if (valid) {
        $(emailSelector).removeAttr('aria-invalid aria-describedby');
      } else {
        this.source.set('params.invalid', 'email');
      }
      if (!this.validateConfirmEmail()) {
        this.source.set('params.invalid', 'confirm-email');
      }
      validator = emailForm.validate();
      return validator.check(emailSelector);
    },
    validateEmail: function (focused) {
      var emailSelector = aboutEmailFormSelector + ' input[name=email]',
        emailForm = $(aboutEmailFormSelector),
        validator,
        valid,
        self = this;
      emailForm.validation();
      if (focused === false && !!self.email()) {
        valid = !!$(emailSelector).valid();
        if (valid) {
          $(emailSelector).removeAttr('aria-invalid aria-describedby');
        }
        return valid;
      }
      validator = emailForm.validate();
      return validator.check(emailSelector);
    },
    validateRequest: function () {
      if (this.checkRequest != null && $.inArray(this.checkRequest.readyState, [1, 2, 3])) {
        this.checkRequest.abort();
        this.checkRequest = null;
      }
    },
    validateConfirmEmail: function () {
      var emailSelector = aboutEmailFormSelector + ' input[name=confirm-email]',
        emailForm = $(aboutEmailFormSelector),
        valid;
      emailForm.validation();
      valid = !!$(emailSelector).valid();
      if (valid) {
        $(emailSelector).removeAttr('aria-invalid aria-describedby');
      }
      return valid;
    }
  });
});

